import axiosInstance from "@/config/axiosInstance";

const JOBS_API_BASE = "https://endsofttech.com/api/jobs";

export const getPublishedJobs = async (params = {}) => {
  const response = await axiosInstance.get(`${JOBS_API_BASE}/published`, {
    params,
  });
  return response.data;
};

export const getJobBySlug = async (slug) => {
  const response = await axiosInstance.get(`${JOBS_API_BASE}/published/${slug}`);
  return response.data;
};
